import { Box, Button, Paper, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR } from "../constants";

interface LeadsBulkActionBarProps {
  data: LeadsManagementData;
}

export default function LeadsBulkActionBar({ data }: LeadsBulkActionBarProps) {
  const { selectedCount, clearSelection, requestBulkReport, canReportLeads } = data;

  if (selectedCount === 0) return null;

  return (
    <Paper
      elevation={4}
      sx={{
        position: "fixed",
        bottom: 26,
        left: "calc(50% + 129px)",
        transform: "translateX(-50%)",
        borderRadius: 3,
        p: "12px 14px 12px 22px",
        display: "flex",
        alignItems: "center",
        gap: 2.5,
        zIndex: 30,
      }}
    >
      <Typography sx={{ fontSize: 14.5, fontWeight: 500, color: "#212121" }}>
        {selectedCount} lead{selectedCount > 1 ? "s" : ""} selected
      </Typography>
      <Box
        component="span"
        onClick={clearSelection}
        sx={{ fontSize: 13.5, color: "#757575", cursor: "pointer" }}
      >
        Clear
      </Box>
      <Button
        variant="contained"
        startIcon={<SendIcon />}
        disabled={!canReportLeads}
        onClick={requestBulkReport}
        data-tracker="930"
        sx={{ bgcolor: BRAND_COLOR, "&:hover": { bgcolor: "#7B1FA2" }, letterSpacing: "0.4px" }}
      >
        Report to brand
      </Button>
    </Paper>
  );
}
